import React, {useContext, useCallback, useState, useEffect} from 'react';

import Slideshow from '~/src/components/slideshow/Slideshow';
import RatingOverlay from '~/src/components/rating/overlay/RatingOverlay';

import TypeContext from '~/src/components/context/TypeContext';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {pushRoute} from '~/src/utilities/helpers/router';
import {getCategoryUrl, getContentUrl} from '~/src/utilities/helpers/link';
import {Hashes} from '~/src/utilities/constants/hash';
import {onRating} from '~/src/utilities/helpers/rating';

import css from './SlideshowContent.module.scss';

const SlideshowContent = ({isFirstPageRequest, content, type, pageKey, id}) => {
    const sitemap = useContext(SitemapContext);

    const [showRatingOverlay, setShowRatingOverlay] = useState(false);

    const onClose = useCallback(() => {
        if (isFirstPageRequest) {
            pushRoute(sitemap.all, getCategoryUrl(content.meta.mainCategoryFullUrlPath));
        } else {
            window.history.back();
        }
    }, []);

    const toggleRatingOverlay = useCallback(() => {
        if (showRatingOverlay) {
            pushRoute(sitemap.all, getContentUrl(content.meta.url), true);
        }

        setShowRatingOverlay(!showRatingOverlay);
    }, [showRatingOverlay]);

    useEffect(() => {
        if (process.browser && window.location.hash === `#${Hashes.RATING_SECTION}`) {
            setShowRatingOverlay(true);
        }
    }, []);

    const nextpage = content.nextpage;

    const onRatingAction = useCallback(
        onRating({
            id,
            title: content.meta.teaser.default.title,
            authors: content.meta.authors,
            fullUrlPath: content.meta.mainCategoryFullUrlPath,
            type
        }),
        [id]
    );

    return (
        <TypeContext value={type}>
            <div className={css.slideshowContent}>
                <Slideshow
                    id={id}
                    slideshow={content}
                    meta={content.meta}
                    onClose={onClose}
                    isStandalone={true}
                    nextpage={nextpage}
                    onRatingClick={toggleRatingOverlay}
                />

                {showRatingOverlay && <RatingOverlay metadataId={id} onRating={onRatingAction} onClose={toggleRatingOverlay} />}
            </div>
        </TypeContext>
    );
};

export default SlideshowContent;
